module.exports = __webpack_public_path__ + "img/1506403751.b073425a.jpg";